module.exports = __webpack_public_path__ + "img/3dmax.d93e1cfb.svg";